export function chunkArray(myArray, chunk_size) {
    let
        index = 0,
        arrayLength = myArray.length,
        tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
        let myChunk = myArray.slice(index, index + chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
    }

    return tempArray;
}


// WEBPACK FOOTER //
// ./assets/js/modules/chunkArray.js